export default __webpack_public_path__ + "static/2378-685df439594485b0890ffc1dc7dda476.jpeg";